export const getDefaultOrgNode = (env) => {
    if (env === "dev-v1") {
        return "711";
    }
    if (env === "stage-v1") {
        return "845";
    }
    return "845";
};
export const getEnvironment = (prodHostname) => {
    const h = window.location.hostname;
    return h.includes("dev")
        ? "dev"
        : h.includes("stage")
            ? "stage"
            : h === prodHostname
                ? "prod"
                : "stage";
};
//# sourceMappingURL=parcel.js.map